(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["splash-accelerated-checkout"] && !Shopify.designMode) return;
  try {
    class SplashDirectCheckout extends HTMLElement {
    #qtyPlusButton = null;
    #qtyMinusButton = null;
    #qtyInput = null;
    #checkoutButton = null;
    #selectedVariantId = null;

    constructor() {
      super();
    }

    connectedCallback() {
      this.#qtyPlusButton = this.querySelector('[data-plus-button]');
      this.#qtyMinusButton = this.querySelector('[data-minus-button]');
      this.#qtyInput = this.querySelector('[data-quantity-input]');
      this.#checkoutButton = this.querySelector('[data-checkout-button]');
      this.#selectedVariantId = this.dataset.variantId;

      if (parseInt(this.#qtyInput.value, 10) <= 10) {
        this.#qtyMinusButton.disabled = true;
      }

      this.#qtyMinusButton.addEventListener('click', (event) => {
        this.minusQuantity();
      });

      this.#qtyPlusButton.addEventListener('click', (event) => {
        this.plusQuantity();
      });

      this.#checkoutButton.addEventListener('click', (event) => {
        let checkoutUrl = `/cart/${this.dataset.variantId}:${this.#qtyInput.value}`;
        if (this.dataset.shopPay === 'true') {
          checkoutUrl = `${checkoutUrl}?payment=shop_pay`;
        }
        this.#checkoutButton.setAttribute('data-added', true);
        setTimeout(() => {
          this.#checkoutButton.setAttribute('data-added', false);
        }, 1000);
        window.location.href = checkoutUrl;
      });

      this.#qtyInput.addEventListener('change', (event) => {
        this.changeQuantity();
      });

      document.addEventListener('variant:selected', this.onVariantSelected.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('variant:selected', this.onVariantSelected);
    }

    onVariantSelected(event) {
      const optionId = event.detail.resource.id;
      const productGrid = this.closest('[data-product-grid-content]');
      const variantOption = productGrid.querySelector(`variant-picker [data-option-value-id="${optionId}"]`);
      const variantId = variantOption.dataset.variantId;
      this.setAttribute('data-variant-id', variantId);
      this.#selectedVariantId = variantId;
    }

    minusQuantity() {
      const currentValue = parseInt(this.#qtyInput.value, 10);
      if (currentValue <= 1) {
        return;
      }
      const newValue = currentValue - 1;
      this.#qtyInput.value = newValue;
      if (newValue === 1) {
        this.#qtyMinusButton.disabled = true;
      }
    }

    plusQuantity() {
      const currentValue = parseInt(this.#qtyInput.value, 10);
      const newValue = currentValue + 1;
      this.#qtyInput.value = newValue;
      this.#qtyMinusButton.disabled = false;
    }

    changeQuantity() {
      const rawValue = this.#qtyInput.value;
      if (!rawValue || rawValue === '') {
        this.#qtyInput.value = 0;
        return;
      }
      const newValue = parseInt(rawValue, 10);
      if (newValue <= 1) {
        this.#qtyMinusButton.disabled = true;
        return;
      }
      this.#qtyMinusButton.disabled = false;
    }
  }
  if (!customElements.get('splash-direct-checkout')) {
    customElements.define('splash-direct-checkout', SplashDirectCheckout);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["splash-add-to-case-button"] && !Shopify.designMode) return;
  try {
    class SplashPDPAddToCase extends HTMLElement {
    static MAX_BOTTLES = 15;

    #config = null;

    #quantityInput = null;
    #quantityPlusButton = null;
    #quantityMinusButton = null;
    #atcButton = null;
    #caseAlert = null;

    constructor() {
      super();
    }

    connectedCallback() {
      const configTpl = this.querySelector('script[data-json]');
      this.#config = JSON.parse(configTpl.textContent);

      const totalBottles = this.getCaseBottleTotal();

      this.#quantityInput = this.querySelector('input[data-quantity-input]');
      this.#quantityPlusButton = this.querySelector('button[data-plus-button]');
      this.#quantityMinusButton = this.querySelector('button[data-minus-button]');
      this.#atcButton = this.querySelector('button[data-atc-button]');
      this.#caseAlert = this.querySelector('div[data-case-alert]');

      if (totalBottles === SplashPDPAddToCase.MAX_BOTTLES) {
        this.#quantityInput.disabled = true;
        this.#quantityPlusButton.disabled = true;
        this.#quantityMinusButton.disabled = true;
        this.#atcButton.disabled = true;
        this.#caseAlert.classList.remove('hidden');
      }

      if (this.dataset.productAvailable === 'false') {
        this.#quantityInput.disabled = true;
        this.#quantityPlusButton.disabled = true;
        this.#quantityMinusButton.disabled = true;
        this.#atcButton.disabled = true;
      }

      this.#quantityPlusButton.addEventListener('click', (event) => {
        const quantity = parseInt(this.#quantityInput.value, 10);
        this.#quantityInput.value = quantity + 1;
      });

      this.#quantityMinusButton.addEventListener('click', (event) => {
        const quantity = parseInt(this.#quantityInput.value, 10);
        if (quantity > 1) {
          this.#quantityInput.value = quantity - 1;
        }
      });

      this.#atcButton.addEventListener('click', (event) => {
        const config = this.getCaseConfig();
        const caseBottleCount = this.getCaseBottleTotal();
        const qtyToAdd = parseInt(this.#quantityInput.value, 10);
        const availableToAdd = SplashPDPAddToCase.MAX_BOTTLES - caseBottleCount;
        this.#atcButton.setAttribute('data-added', true);

        let newQuantity = qtyToAdd;
        if (qtyToAdd > availableToAdd) {
          newQuantity = availableToAdd;
        }
        const existingEntry = config.find((item) => item.product.variantId === this.#config.variantId);
        if (existingEntry) {
          existingEntry.quantity = existingEntry.quantity + newQuantity;
        } else {
          const newItem = {
            quantity: newQuantity,
            product: this.#config,
          };
          config.push(newItem);
        }
        this.setCaseConfig(config);
        setTimeout(() => {
          this.#atcButton.setAttribute('data-added', false);
        }, 1000);
        window.location.href = this.dataset.redirectUrl;
      });
    }

    getCaseConfig() {
      const configRaw = localStorage.getItem('splash_byoc_config');
      if (!configRaw) {
        return [];
      }
      return JSON.parse(configRaw);
    }

    getCaseBottleTotal() {
      return this.getCaseConfig().reduce((acc, cur) => {
        return acc + cur.quantity;
      }, 0);
    }

    setCaseConfig(config) {
      localStorage.setItem('splash_byoc_config', JSON.stringify(config));
    }
  }
  if (!customElements.get('splash-pdp-add-to-case')) {
    customElements.define('splash-pdp-add-to-case', SplashPDPAddToCase);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["splash-byoc-button"] && !Shopify.designMode) return;
  try {
    class SplashAddToCaseButton extends HTMLElement {
    static MAX_BOTTLES = 15;

    #showQuantity = false;
    #disableControls = false;

    #addToCaseButton = null;
    #quantityMinusButton = null;
    #quantityPlusButton = null;
    #quantityInput = null;

    #config = null;

    constructor() {
      super();
    }

    connectedCallback() {
      const configTpl = this.querySelector('script[data-json]');
      this.#config = JSON.parse(configTpl.textContent);
      const existingItemConfig = this.getCaseConfigItem();

      this.#addToCaseButton = this.querySelector('[data-add-to-case-button]');
      this.#quantityMinusButton = this.querySelector('[data-minus-button]');
      this.#quantityPlusButton = this.querySelector('[data-plus-button]');
      this.#quantityInput = this.querySelector('[data-quantity-input]');

      this.toggleControls();

      // Stop clicks within the query selector from navigating to the PDP
      this.querySelector('.quantity-selector').addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
      });

      if (existingItemConfig) {
        this.showQuantity = true;
        this.#quantityInput.value = existingItemConfig.quantity;
        if (existingItemConfig.quantity === 1) {
          this.#quantityMinusButton.disabled = true;
        }
      }

      this.#addToCaseButton.addEventListener('click', (event) => {
        if (this.#addToCaseButton.disabled) {
          return;
        }
        this.showQuantity = true;
        this.#quantityInput.value = 1;
        this.addOrUpdateCaseItem();
        this.dispatchCaseUpdateEvent();
      });

      this.#quantityMinusButton.addEventListener('click', (event) => {
        if (this.#quantityMinusButton.disabled) {
          return;
        }
        const quantityValue = parseInt(this.#quantityInput.value, 10);
        if (quantityValue > 1) {
          this.decreaseProductQty();
          this.dispatchCaseUpdateEvent();
        }
      });

      this.#quantityPlusButton.addEventListener('click', (event) => {
        if (this.#quantityPlusButton.disabled) {
          return;
        }
        this.increaseProductQty();
        this.dispatchCaseUpdateEvent();
      });

      document.addEventListener('case:update', this.onCaseUpdateEvent.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('case:update', this.onCaseUpdateEvent);
    }

    onCaseUpdateEvent(event) {
      const configItem = this.getCaseConfigItem();
      if (configItem) {
        this.#quantityInput.value = configItem.quantity;
      } else {
        this.#quantityInput.value = 0;
        this.showQuantity = false;
      }
      this.toggleControls();
    }

    dispatchCaseUpdateEvent() {
      const caseUpdateEvent = new CustomEvent('case:update', {
        detail: {
          variantId: this.#config.variantId,
          event: 'update',
        },
      });
      document.dispatchEvent(caseUpdateEvent);
    }

    increaseProductQty() {
      const config = this.getCaseConfig();
      config.forEach((entry) => {
        if (entry.product.variantId === this.#config.variantId) {
          entry.quantity = entry.quantity + 1;
        }
      });
      this.setCaseConfig(config);
    }

    decreaseProductQty() {
      const config = this.getCaseConfig();
      const product = config.find((item) => item.product.variantId === this.#config.variantId);
      if (product.quantity === 1) {
        this.showQuantity = false;
        this.removeCaseConfigItem();
      } else {
        product.quantity = product.quantity - 1;
        this.setCaseConfig(config);
      }
    }

    getCaseConfigItem() {
      const caseConfig = this.getCaseConfig();
      return caseConfig.find((item) => item.product.variantId === this.#config.variantId);
    }

    removeCaseConfigItem() {
      const caseConfig = this.getCaseConfig();
      const filtered = caseConfig.filter((item) => item.product.variantId !== this.#config.variantId);
      this.setCaseConfig(filtered);
    }

    getCaseConfig() {
      const configRaw = localStorage.getItem('splash_byoc_config');
      if (!configRaw) {
        this.setCaseConfig([]);
        return [];
      }
      return JSON.parse(configRaw);
    }

    setCaseConfig(config) {
      localStorage.setItem('splash_byoc_config', JSON.stringify(config));
    }

    getCaseBottleTotal() {
      return this.getCaseConfig().reduce((acc, cur) => {
        return acc + cur.quantity;
      }, 0);
    }

    toggleControls() {
      const isOOS = this.querySelector('[data-fg-oos-text][data-fg-atc-text]');
      if (isOOS) {
        this.disableControls = true;
        return;
      }
      const bottleTotal = this.getCaseBottleTotal();
      if (bottleTotal === SplashAddToCaseButton.MAX_BOTTLES) {
        this.disableControls = true;
      } else {
        this.disableControls = false;
      }
    }

    addOrUpdateCaseItem() {
      const config = this.getCaseConfig();
      const existingProduct = config.find((item) => item.product.variantId === this.#config.variantId);
      if (existingProduct) {
        console.log('Product already exists. do... what? We probably shouldnt be able to do this');
      } else {
        const newItem = {
          quantity: 1,
          product: this.#config,
        };
        config.push(newItem);
      }
      this.setCaseConfig(config);
    }

    set disableControls(value) {
      if (this.dataset.productAvailable === 'false') {
        this.#disableControls = true;
        this.#addToCaseButton.disabled = true;
        this.#quantityMinusButton.disabled = true;
        this.#quantityPlusButton.disabled = true;
        return;
      }
      this.#disableControls = value;
      if (value) {
        this.#addToCaseButton.disabled = true;
        this.#quantityMinusButton.disabled = false;
        this.#quantityPlusButton.disabled = true;
      } else {
        this.#addToCaseButton.disabled = false;
        this.#quantityMinusButton.disabled = false;
        this.#quantityPlusButton.disabled = false;
      }
      if (this.#quantityInput.value == 1) {
        this.#quantityMinusButton.disabled = true;
      }
    }

    get disableControls() {
      return this.#disableControls;
    }

    set showQuantity(value) {
      this.#showQuantity = value;
      if (value) {
        this.setAttribute('data-show-quantity', '');
      } else {
        this.removeAttribute('data-show-quantity');
      }
    }

    get showQuantity() {
      return this.#showQuantity;
    }
  }
  if (!customElements.get('splash-add-to-case-button')) {
    customElements.define('splash-add-to-case-button', SplashAddToCaseButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["splash-byoc-form"] && !Shopify.designMode) return;
  try {
    class SplashBYOCForm extends HTMLElement {
    static MAX_BOTTLES = 15;

    #statusTextEl = null;
    #statusPriceEl = null;
    #progressBarEl = null;
    #atcButtonEl = null;
    #viewCaseEls = [];

    #config = {
      caseCompleteLabel: '',
      caseIncompleteLabel: '',
    };

    #positionFixed = false;
    #completeMessageEl = null;
    #hasCompletedOnce = false;
    #reactiveDisplay = true;

    #onResizeDebounce = null;

    constructor() {
      super();
    }

    connectedCallback() {
      this.#reactiveDisplay = this.dataset.mode === 'reactive';

      this.#config = JSON.parse(this.querySelector('script[data-json]').textContent);

      this.#statusTextEl = this.querySelector('.status-text');
      const currentRemainingText = this.getBottlesRemainingText();
      this.#statusTextEl.textContent = currentRemainingText;

      this.#completeMessageEl = this.querySelector('[data-message="once-complete"]');

      this.#statusPriceEl = this.querySelector('.status-price');
      const currentPriceTotal = this.getCasePriceTotal();
      this.#statusPriceEl.textContent = `$${currentPriceTotal}`;

      this.#progressBarEl = this.querySelector('.progress-bar');
      const currentProgress = this.getCurrentProgressPercent();
      this.#progressBarEl.setAttribute('style', `--progress-width: ${currentProgress}%`);

      this.#atcButtonEl = this.querySelector('[data-atc-button]');

      this.#atcButtonEl.addEventListener('click', (event) => {
        this.addCaseToCart();
      });

      // figure out if we should be in fixed position or not based on page load scroll position
      this.onScrollendEvent();

      if (currentProgress === 100) {
        this.#hasCompletedOnce = true;
        this.classList.add('case-full');
      }

      if (window.innerWidth <= 750 && this.#reactiveDisplay) {
        this.#positionFixed = true;
        this.classList.add('fixed-bottom');
      }

      this.#viewCaseEls = this.querySelectorAll('[data-view-button]');
      this.#viewCaseEls.forEach((button) => {
        if (currentProgress === 0) {
          button.disabled = true;
        }
        button.addEventListener('click', (event) => {
          event.preventDefault();
          document.querySelector('splash-byoc-modal').showModal();
        });
      });

      this.querySelector('[data-modal-close]').addEventListener('click', (event) => {
        document.querySelector('splash-byoc-modal').hideModal();
      });

      document.addEventListener('case:update', this.onCaseUpdateEvent.bind(this));
      document.addEventListener('scrollend', this.onScrollendEvent.bind(this));
      window.addEventListener('resize', this.onResizeEvent.bind(this));
    }

    async addCaseToCart() {
      const config = this.getCaseConfig();
      const caseId = Date.now();
      const cartItems = config.map((item) => {
        return {
          id: item.product.variantId,
          quantity: item.quantity,
          properties: {
            _byoc_id: caseId
          },
        };
      });
      const requestBody = {
        items: cartItems,
        sections: '',
      };
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const cartItemComponentsSectionIds = [];
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          cartItemComponentsSectionIds.push(item.dataset.sectionId);
        }
      });
      requestBody.sections = cartItemComponentsSectionIds.join(',');
      this.#atcButtonEl.setAttribute('data-added', true);
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });
        const result = await response.json();
        const newEvent = new CustomEvent('cart:update', { detail: { data: { sections: result.sections } } });
        document.querySelector('splash-byoc-modal').hideModal();
        this.clearCaseConfig();
        setTimeout(() => {
          this.#atcButtonEl.setAttribute('data-added', false);
          document.dispatchEvent(newEvent);
        }, 500);
      } catch (e) {
        console.error('Add to cart request error', e);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('case:update', this.onCaseUpdateEvent);
      document.removeEventListener('scrollend', this.onScrollendEvent);
      window.removeEventListener('resize', this.onResizeEvent);
    }

    onCaseUpdateEvent(event) {
      const updatedRemainingText = this.getBottlesRemainingText();
      this.#statusTextEl.textContent = updatedRemainingText;

      const updatedPriceTotal = this.getCasePriceTotal();
      this.#statusPriceEl.textContent = `$${updatedPriceTotal}`;

      const updatedProgress = this.getCurrentProgressPercent();
      if (updatedProgress !== 100 && this.#hasCompletedOnce) {
        this.#completeMessageEl.classList.remove('hidden');
      }
      this.#viewCaseEls.forEach((button) => {
        if (updatedProgress > 0) {
          button.disabled = false;
        } else {
          button.disabled = true;
        }
      });
      if (event.detail.event === 'clear') {
        this.#completeMessageEl.classList.add('hidden');
        this.#hasCompletedOnce = false;
      }
      if (updatedProgress === 100) {
        this.#completeMessageEl.classList.add('hidden');
        this.classList.add('case-full');
        if (!this.#hasCompletedOnce) {
          this.#hasCompletedOnce = true;
        }
      } else {
        this.classList.remove('case-full');
      }
      this.#progressBarEl.setAttribute('style', `--progress-width: ${updatedProgress}%`);
    }

    onScrollendEvent(event) {
      if (!this.#reactiveDisplay) {
        return;
      }
      const formOffsets = this.getBoundingClientRect();
      const documentOffsets = document.querySelector('body').getBoundingClientRect();
      if (formOffsets.top < 66 && !this.#positionFixed && window.innerWidth > 750) {
        this.#positionFixed = true;
        this.classList.add('fixed-bottom');
      }
      if (documentOffsets.top > -40 && window.innerWidth > 750) {
        this.#positionFixed = false;
        this.classList.remove('fixed-bottom');
      }
    }

    async debounceOnResize() {
      if (!this.#reactiveDisplay) {
        return;
      }
      clearTimeout(this.#onResizeDebounce);
      this.#onResizeDebounce = setTimeout(() => {
        if (window.innerWidth <= 750) {
          this.classList.add('fixed-bottom');
        } else {
          this.onScrollendEvent();
        }
      }, 300);
    }

    onResizeEvent(event) {
      this.debounceOnResize();
    }

    getBottlesRemainingText() {
      const total = this.getCaseConfig().reduce((acc, cur) => {
        return acc + cur.quantity;
      }, 0);
      const remaining = SplashBYOCForm.MAX_BOTTLES - total;
      if (remaining === 1) {
        // return `Add 1 bottle`;
        return this.#config.caseIncompleteLabel.replace('[remaining]', '1 bottle');
      } else if (remaining === 0) {
        return this.#config.caseCompleteLabel;
      }
      return this.#config.caseIncompleteLabel.replace('[remaining]', `${remaining} bottles`);
      // return `Add ${remaining} bottles`;
    }

    getCurrentProgressPercent() {
      const total = this.getCaseConfig().reduce((acc, cur) => {
        return acc + cur.quantity;
      }, 0);

      if (total >= SplashBYOCForm.MAX_BOTTLES) {
        return 100;
      } else if (total === 0) {
        return 0;
      } else {
        return (total / SplashBYOCForm.MAX_BOTTLES) * 100;
      }
    }

    getCasePriceTotal() {
      const total = this.getCaseConfig().reduce((acc, cur) => {
        return acc + cur.product.price * cur.quantity;
      }, 0);
      return (total / 100).toFixed(2);
    }

    getCaseConfig() {
      const configRaw = localStorage.getItem('splash_byoc_config');
      if (!configRaw) {
        return [];
      }
      return JSON.parse(configRaw);
    }

    clearCaseConfig() {
      localStorage.setItem('splash_byoc_config', JSON.stringify([]));
      this.#hasCompletedOnce = false;
      const caseUpdateEvent = new CustomEvent('case:update', {
        detail: {
          variantId: null,
          event: 'clear',
        },
      });
      document.dispatchEvent(caseUpdateEvent);
    }
  }
  if (!customElements.get('splash-byoc-form')) {
    customElements.define('splash-byoc-form', SplashBYOCForm);
  }

  class SplashBYOCModal extends HTMLElement {
    #modalContainer = null;
    #lastConfig = null;

    constructor() {
      super();
    }

    connectedCallback() {
      const modalTpl = this.querySelector('template[data-tpl="modal"]');
      const modalContentNode = modalTpl.content.cloneNode(true);
      this.#modalContainer = modalContentNode.querySelector('.splash-byoc-modal-underlay');

      this.#modalContainer.querySelector('[data-modal-close]').addEventListener('click', (event) => {
        this.hideModal();
      });

      const config = this.getCaseConfig();
      this.renderProducts(config);

      this.#modalContainer.addEventListener('click', (event) => {
        if (event.target.classList.contains('splash-byoc-modal-underlay')) {
          this.hideModal();
        }
      });

      document.addEventListener('case:update', this.onCaseUpdateEvent.bind(this));

      document.querySelector('body').appendChild(this.#modalContainer);
    }

    disconnectedCallback() {
      document.removeEventListener('case:update', this.onCaseUpdateEvent);
    }

    onCaseUpdateEvent() {
      const config = this.getCaseConfig();
      this.renderProducts(config);
    }

    renderProducts(config) {
      this.#lastConfig = config;
      const productTpl = this.querySelector('template[data-tpl="product"]');
      const productContainer = this.#modalContainer.querySelector('.case-items-grid');
      productContainer.innerHTML = '';
      config.forEach((item) => {
        const productContentNode = productTpl.content.cloneNode(true);

        const title = productContentNode.querySelector('[data-title]');
        title.textContent = item.product.title;

        const image = productContentNode.querySelector('[data-image]');
        image.setAttribute('src', item.product.featuredImage);

        const price = productContentNode.querySelector('[data-price]');
        const comparePrice = productContentNode.querySelector('[data-compare-price]');
        price.textContent = `$${(item.product.price / 100).toFixed(2)}`;
        comparePrice.textContent = `$${(item.product.comparePrice / 100).toFixed(2)}`;

        const byocButton = productContentNode.querySelector('splash-add-to-case-button');
        byocButton.querySelector('script[data-json]').textContent = JSON.stringify(item.product);

        const removeButton = productContentNode.querySelector('[data-item-remove]');
        removeButton.addEventListener('click', (event) => {
          this.removeProductFromCase(item);
        });

        productContainer.appendChild(productContentNode);
      });
    }

    showModal() {
      this.#modalContainer.classList.remove('hidden');
    }

    hideModal() {
      this.#modalContainer.classList.add('hidden');
    }

    removeProductFromCase(toRemove) {
      const config = this.getCaseConfig();
      const filtered = config.filter((item) => item.product.variantId !== toRemove.product.variantId);
      localStorage.setItem('splash_byoc_config', JSON.stringify(filtered));
      const newConfig = this.getCaseConfig();
      this.renderProducts(newConfig);
      this.dispatchCaseUpdateEvent(toRemove);
    }

    dispatchCaseUpdateEvent(toRemove) {
      const caseUpdateEvent = new CustomEvent('case:update', {
        detail: {
          variantId: toRemove.product.variantId,
          event: 'update',
        },
      });
      document.dispatchEvent(caseUpdateEvent);
    }

    getCaseConfig() {
      const configRaw = localStorage.getItem('splash_byoc_config');
      if (!configRaw) {
        return [];
      }
      return JSON.parse(configRaw);
    }
  }
  if (!customElements.get('splash-byoc-modal')) {
    customElements.define('splash-byoc-modal', SplashBYOCModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["splash-club-form"] && !Shopify.designMode) return;
  try {
    class SplashClubForm extends HTMLElement {
    // Maps a key to a recharge subscription interval (selling_plan.options name: 'Order Frequency and Unit')
    #frequencies = {
      high: '1-month',
      mid: '2-month',
      low: '3-month',
    };

    /*
     * Maps a key to a product variant option.
     * Currently the Splash club subscription is comprised of 6 products - 6 pack or 15 pack red/white/mixed with 3 quality tiers
     * Each product is a specific case size and quality tier (ex. 15 pack low tier) with product variants of each wine type.
     * This provides a way of doing a lookup on a fixed key should these variant option names ever need to change
     */
    #variantTypes = {
      red: 'Red',
      white: 'White',
      mixed: 'Mixed',
    };

    #choiceData = {
      size: 'small',
      frequency: 'high',
      type: 'red',
      tier: 3,
    };

    #productConfig = [];

    #stickyBar = null;

    constructor() {
      super();
    }

    connectedCallback() {
      const configScript = this.querySelector('[data-config="selling_plans"]');
      this.#productConfig = JSON.parse(configScript.textContent);

      const stickyBarTpl = this.querySelector('template[data-tpl="sticky-bar"]');
      this.#stickyBar = document.importNode(
        stickyBarTpl.content.querySelector('.splash-club-form-sticky-cart-bar'),
        true
      );

      const stickyBarButton = this.#stickyBar.querySelector('button');
      stickyBarButton.addEventListener('click', async (event) => {
        const selectedProduct = this.getSelectedProductData();
        let selectedVariant = null;
        // Default to the single variant in Cellar if we're at tier 1
        if(selectedProduct.tier === 1) {
          selectedVariant = selectedProduct.variants[0];
        } else {
          selectedVariant = selectedProduct.variants.find((variant) =>
            variant.options.includes(this.valueForVariantType())
          )
        };

        const selectedSellingPlan = selectedProduct.sellingPlans.find((plan) => {
          const freqOption = plan.options.find((option) => option.name.toLowerCase().includes('order frequency'));
          if (freqOption.values[0] === this.#frequencies[this.#choiceData.frequency]) {
            return true;
          }
          return false;
        });
        if (!selectedSellingPlan) {
          console.error('No selling plan found for product', selectedProduct);
          return;
        }
        stickyBarButton.disabled = true;

        const requestBody = {
          items: [
            {
              id: selectedVariant.id,
              quantity: 1,
              selling_plan: selectedSellingPlan.selling_plans[0].id,
            },
          ],
          sections: '',
        };

        try {
          const cartItemsComponents = document.querySelectorAll('cart-items-component');
          const cartItemComponentsSectionIds = [];
          cartItemsComponents.forEach((item) => {
            if (item instanceof HTMLElement && item.dataset.sectionId) {
              cartItemComponentsSectionIds.push(item.dataset.sectionId);
            }
          });
          requestBody.sections = cartItemComponentsSectionIds.join(',');

          stickyBarButton.setAttribute('data-added', true);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
          });
          const result = await response.json();
          const newEvent = new CustomEvent('cart:update', { detail: { data: { sections: result.sections } } });
          setTimeout(() => {
            stickyBarButton.setAttribute('data-added', false);
            document.dispatchEvent(newEvent);
          }, 500);
        } catch (e) {
          console.error('Add to cart request error', e);
        }

        stickyBarButton.disabled = false;
      });
      document.querySelector('body').appendChild(this.#stickyBar);

      const frequencyBtnTpl = this.querySelector('template[data-tpl="freq_buttons"]');
      const frequencyBtnNode = frequencyBtnTpl.content.cloneNode(true);

      const sameSizeProducts = this.getProductTiers();

      const frequencyButtonsContainer = this.querySelector('.frequency-options');
      frequencyButtonsContainer.appendChild(frequencyBtnNode);

      const quantityButtons = this.querySelectorAll('[data-qty-btn]');
      quantityButtons.forEach((button) => {
        if (button.dataset.quantity === this.#choiceData.size) {
          button.setAttribute('data-selected', true);
        }
        button.addEventListener('click', (event) => {
          quantityButtons.forEach((b) => b.setAttribute('data-selected', false));
          button.setAttribute('data-selected', true);
          this.updateQuantity(button.dataset.quantity);
        });
      });

      const frequencyButtons = this.querySelectorAll('[data-freq-btn]');
      frequencyButtons.forEach((button) => {
        if (button.dataset.freq === this.#choiceData.frequency) {
          button.setAttribute('data-selected', true);
        }
        button.addEventListener('click', (event) => {
          frequencyButtons.forEach((b) => b.setAttribute('data-selected', false));
          button.setAttribute('data-selected', true);
          this.updateFrequency(button.dataset.freq);
        });
      });

      const variantButtons = this.querySelectorAll('[data-variant-btn]');
      variantButtons.forEach((button) => {
        if (button.dataset.variantKey === this.#choiceData.type) {
          button.setAttribute('data-selected', true);
        }
        button.addEventListener('click', (event) => {
          variantButtons.forEach((b) => b.setAttribute('data-selected', false));
          button.setAttribute('data-selected', true);
          this.updateVariant(button.dataset.variantKey);
        });
      });

      const tierButtons = this.querySelectorAll('[data-tier-btn]');
      tierButtons.forEach((button) => {
        const productForTier = sameSizeProducts.find((product) => product.tier == button.dataset.tier);
        if (productForTier.tier < 3) {
          const priceDiff = this.getPriceDifferenceForTier(sameSizeProducts, button.dataset.tier);
          button.querySelector('.tier-price-badge').textContent = this.getPriceBadgeText(priceDiff);
        }
        if (button.dataset.tier == this.#choiceData.tier) {
          button.setAttribute('data-selected', true);
        }
        const mobileSelectButton = button.querySelector('.tier-option-button button');
        if (mobileSelectButton) {
          mobileSelectButton.addEventListener('click', (mevent) => {
            mevent.preventDefault();
            mevent.stopPropagation();
            tierButtons.forEach((b) => {
              const tier = button.dataset.tier;
              if (b.dataset.tier == tier) {
                b.setAttribute('data-selected', true);
              } else {
                b.setAttribute('data-selected', false);
              }
            });
            this.updateTier(button.dataset.tier);
          });
        }
        button.addEventListener('click', (event) => {
          if (button.classList.contains('mobile')) {
            if (button.classList.contains('expand')) {
              button.classList.remove('expand');
            } else {
              button.classList.add('expand');
            }
            tierButtons.forEach((b) => {
              if (b.classList.contains('mobile') && b.dataset.tier != button.dataset.tier) {
                b.classList.remove('expand');
              }
            });
            return;
          }

          tierButtons.forEach((b) => {
            const tier = button.dataset.tier;
            if (b.dataset.tier == tier) {
              b.setAttribute('data-selected', true);
            } else {
              b.setAttribute('data-selected', false);
            }
          });
          this.updateTier(button.dataset.tier);
        });
      });

      this.updateStickyBar();
    }

    updateQuantity(value) {
      this.#choiceData.size = value;
      this.updateTierButtons();
      this.updateStickyBar();
    }

    updateFrequency(value) {
      this.#choiceData.frequency = value;
      this.updateStickyBar();
    }

    updateVariant(value) {
      this.#choiceData.type = value;

      this.getProductTiers().forEach((product) => {
        const hasVariant = product.variants.find((variant) => {
          if (this.#choiceData.type === 'red' && product.tier == 1) {
            return variant;
          } else {
            return variant.options.includes(this.#variantTypes[this.#choiceData.type])
          }
        });
        if (!hasVariant) {
          const tierButtons = this.querySelectorAll(`[data-tier-btn][data-tier="${product.tier}"]`);
          tierButtons.forEach((button) => {
            // Flip the choice to tier 2 if someone tries to get a white/mixed cellar pack.
            if (button.dataset.selected === 'true') {
              button.setAttribute('data-selected', false);
              this.#choiceData.tier = 2;
              this.querySelectorAll(`[data-tier-btn][data-tier="2"]`).forEach((t2btn) => {
                t2btn.setAttribute('data-selected', true);
              });
            }
            let actualButton = button;
            if (button.classList.contains('mobile')) {
              actualButton = button.querySelector('button');
            }
            actualButton.disabled = true;
            actualButton.setAttribute('aria-disabled', true);
          });
        } else {
          const tierButtons = this.querySelectorAll(`[data-tier-btn][data-tier="${product.tier}"]`);
          tierButtons.forEach((button) => {
            let actualButton = button;
            if (button.classList.contains('mobile')) {
              actualButton = button.querySelector('button');
            }
            actualButton.disabled = false;
            actualButton.setAttribute('aria-disabled', false);
          });
        }
      });

      this.updateStickyBar();
    }

    updateTier(value) {
      this.#choiceData.tier = value;
      this.updateStickyBar();
    }

    /**
     * Update the tier buttons when some dependency changes like pack size and requires
     * recomputing price differences
     */
    updateTierButtons() {
      const sameSizeProducts = this.getProductTiers();
      const tierButtons = this.querySelectorAll('[data-tier-btn]');
      tierButtons.forEach((button) => {
        const productForTier = sameSizeProducts.find((product) => product.tier == button.dataset.tier);
        // Add price badges for only higher tiers to show price difference from base
        if (productForTier.tier < 3) {
          const priceDiff = this.getPriceDifferenceForTier(sameSizeProducts, button.dataset.tier);
          button.querySelector('.tier-price-badge').textContent = `${this.getPriceBadgeText(priceDiff)}`;
        }
        if (button.dataset.tier == this.#choiceData.tier) {
          button.setAttribute('data-selected', true);
        } else {
          button.setAttribute('data-selected', false);
        }
      });
    }

    updateStickyBar() {
      const selectedProduct = this.getSelectedProductData();
      let selectedVariant = null;
      // Default to the single variant in Cellar if we're at tier 1
      if(selectedProduct.tier === 1) {
        selectedVariant = selectedProduct.variants[0];
      } else {
        selectedVariant = selectedProduct.variants.find((variant) =>
          variant.options.includes(this.valueForVariantType())
        )
      };
      const quantityElements = this.#stickyBar.querySelectorAll('[data-choice-quantity]');
      const typeElements = this.#stickyBar.querySelectorAll('[data-choice-type]');
      const tierElements = this.#stickyBar.querySelectorAll('[data-choice-tier]');
      const priceElement = this.#stickyBar.querySelector('[data-choice-price]');
      const freqElement = this.#stickyBar.querySelector('[data-choice-freq]');
      priceElement.textContent = `$${selectedVariant.price / 100}`;
      freqElement.textContent = this.querySelector('.frequency-options [data-selected="true"]').textContent;
      quantityElements.forEach((element) => {
        element.textContent = `${this.#choiceData.size === 'small' ? 6 : 15}`;
      });
      typeElements.forEach((element) => {
        element.textContent = `${this.valueForVariantType()}`;
      });
      tierElements.forEach((element) => {
        element.textContent = this.querySelector('.tier-options [data-selected="true"] .tier-label').textContent;
      });
    }

    valueForVariantType() {
      // Force this to "Red" for tier 1
      if(this.#choiceData.tier == 1) {
        return 'Red';
      }

      return this.#variantTypes[this.#choiceData.type];
    }

    getPriceBadgeText(price) {
      return `Adds $${price}`;
    }

    getPriceDifferenceForTier(products, tier) {
      const baseTierProduct = products.find((product) => product.tier == 3);
      const thisTierProduct = products.find((product) => product.tier == tier);
      const priceDifference = thisTierProduct.variants[0].price - baseTierProduct.variants[0].price;
      return priceDifference / 100;
    }

    getProductTiers() {
      return this.#productConfig.filter((config) => config.size === this.#choiceData.size);
    }

    getSelectedProductData() {
      const found = this.#productConfig.find((config) => {
        if (config.size === this.#choiceData.size && config.tier == this.#choiceData.tier) {
          // Tier 1 "Cellar" only has a single variant
          if (this.#choiceData.tier == 1) {
            return true;
          }

          const foundVariant = config.variants.find((variant) => {
            const foundOption = variant.options.includes(this.valueForVariantType());
            return foundOption;
          });

          if (foundVariant) {
            return true;
          }
          console.error(`Could not find variant with title '${this.#choiceData.type}'`, config);
          return false;
        }
        return false;
      });
      if (!found) {
        console.error(`No product found for choice data`, this.#choiceData, this.#productConfig);
        return null;
      }
      return found;
    }
  }
  if (!customElements.get('splash-club-form')) {
    customElements.define('splash-club-form', SplashClubForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["splash-recharge-points"] && !Shopify.designMode) return;
  try {
    class SplashCash extends HTMLElement {
    rechargeSession = null;

    constructor() {
      super();
    }

    async connectedCallback() {
      const priceEl = this.querySelector('[data-cash]');
      const noCreditsEl = this.querySelector('[data-no-credits]');
      const hasCreditsEl = this.querySelector('[data-has-credits]');
      try {
        const session = await recharge.auth.loginShopifyAppProxy();
        const credits = await recharge.customer.getCreditSummary(session, { include: ['credit_details'] });
        priceEl.textContent = `$${credits.total_available_balance}`;
        if (parseFloat(credits.total_available_balance) > 0) {
          noCreditsEl.classList.add('hidden');
          hasCreditsEl.classList.remove('hidden');
        } else {
          noCreditsEl.classList.remove('hidden');
          hasCreditsEl.classList.add('hidden');
        }
      } catch (e) {
        priceEl.textContent = `$0.00`;
        noCreditsEl.classList.remove('hidden');
        hasCreditsEl.classList.add('hidden');
        console.error(e);
      }
    }
  }
  if (!customElements.get('splash-cash')) {
    customElements.define('splash-cash', SplashCash);
  }
  } catch(e) { console.error(e); }
})();

})();
